class MobileMenu {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getMenuButtonn() {
    let element = this.getElement();
    return element.querySelector('.js-menuButton');
  }

  getMobileMenu() {
    let element = this.getElement();
    return element.querySelector('.js-mobileMenu');
  }

  setMenuButton() {
    let buttonEl = this.getMenuButtonn();
    let menuEl = this.getMobileMenu();

    buttonEl.addEventListener('click', () => {
      menuEl.classList.toggle('active');
      if(!buttonEl.closest('.Header').classList.contains('show-bg')){
        buttonEl.closest('.Header').classList.add('show-bg');
      }
    })
  }

  setEventHandlers() {
    this.setMenuButton();
  }

  init() {
    this.setEventHandlers();
  }
}


const MobileMenuInit = {
  init() {
    const $el = document.querySelector("header");
    if ($el) {
        new MobileMenu($el);
    }
  },
};


export default MobileMenuInit;